import { createElementBlock as o, openBlock as r, createElementVNode as l } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 20 20"
};
function t(a, e) {
  return r(), o("svg", n, [...e[0] || (e[0] = [
    l("path", {
      "fill-rule": "evenodd",
      d: "M16 5.5H6a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5M6 4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z",
      "clip-rule": "evenodd"
    }, null, -1),
    l("path", {
      "fill-rule": "evenodd",
      d: "M1.25 4A2.75 2.75 0 0 1 4 1.25h6a.75.75 0 0 1 0 1.5H4c-.69 0-1.25.56-1.25 1.25v6a.75.75 0 0 1-1.5 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])]);
}
const c = { render: t };
export {
  c as default,
  t as render
};
